import {
    createColumns,
    DataTableColumn,
} from '@/components/ui/data-table-customized'
import { formatCurrency, formatNumeral } from '@/utils/function'
import { ProductGroupRevenue } from '../../types'

export const getColumns = (
    t: (key: string) => string
): DataTableColumn<ProductGroupRevenue>[] =>
    createColumns<ProductGroupRevenue>([
        {
            key: 'product_group_name',
            title: t('product_group_name'),
            width: 200,
            headerClassName: 'text-left',
            cellClassName: 'font-medium',
            render: (value, row) => {
                if (row.isTotal) {
                    return <span className="font-bold">{value}</span>
                }
                return value
            },
        },
        {
            key: 'revenue',
            title: t('revenue'),
            width: 150,
            headerClassName: 'text-right',
            cellClassName: 'text-right',
            render: (value, row) => (
                <span className={row.isTotal ? 'font-bold text-blue-600' : ''}>
                    {formatCurrency(value)}
                </span>
            ),
        },
        {
            key: 'cost',
            title: t('cost_of_goods'),
            width: 150,
            headerClassName: 'text-right',
            cellClassName: 'text-right',
            render: (value, row) => (
                <span
                    className={
                        row.isTotal
                            ? 'font-bold text-orange-600'
                            : 'text-orange-700'
                    }
                >
                    {formatCurrency(value)}
                </span>
            ),
        },
        {
            key: 'gross_profit',
            title: t('gross_profit'),
            width: 150,
            headerClassName: 'text-right',
            cellClassName: 'text-right',
            render: (value, row) => {
                const isPositive = value >= 0
                return (
                    <span
                        className={`font-medium ${
                            row.isTotal
                                ? isPositive
                                    ? 'font-bold text-green-600'
                                    : 'font-bold text-red-600'
                                : isPositive
                                  ? 'text-green-700'
                                  : 'text-red-700'
                        }`}
                    >
                        {formatCurrency(value)}
                    </span>
                )
            },
        },
        {
            key: 'percentage',
            title: t('percentage'),
            width: 100,
            headerClassName: 'text-right',
            cellClassName: 'text-right',
            render: (value, row) => (
                <span className={row.isTotal ? 'font-bold text-blue-600' : ''}>
                    {formatNumeral(value, 2)}%
                </span>
            ),
        },
    ])
